import { debounce } from 'lodash';
import { ReactElement, useEffect, useRef, useState } from 'react';
import { Search } from 'semantic-ui-react';
import useFetchCompanySuggestions from '../../../hooks/company/useFetchCompanySuggestions';
import './WatchlistSelector.scss';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WatchlistSelector({ onSelect, onClose }): ReactElement {
  let searchInputField: any = useRef<any>();
  const [searchText, setSearchText] = useState('');
  const { data: results, isLoading } = useFetchCompanySuggestions(searchText);

  useEffect(() => {
    searchInputField.focus();
  }, []);

  const handleSelect = (data) => {
    onSelect([data.result]);
    close();
  };

  const close = () => {
    onClose();
  };

  const debouncedSetSearchText = debounce(setSearchText, 500);

  const handleChange = (data) => {
    debouncedSetSearchText(data.value);
  };

  const renderResult = (props) => {
    return <div>{props.displayName}</div>;
  };

  return (
    <div className="watchlist-search-wrapper">
      <Search
        loading={isLoading}
        input={{
          icon: 'search',
          iconPosition: 'left',
          ref: (r) => {
            searchInputField = r;
          },
        }}
        fluid
        placeholder="Search"
        results={results}
        showNoResults={false}
        onSearchChange={(e, data) => handleChange(data)}
        onResultSelect={(e, data) => handleSelect(data)}
        resultRenderer={(p) => renderResult(p)}
        onBlur={close}
      />
    </div>
  );
}

export default WatchlistSelector;
